import { useAtomValue } from "jotai";
import { useGetBenefitImplementations } from "state/queries/useGetBenefitImplementations";
import {
  onlyActiveImplementationsState,
  selectedCompanyState,
} from "store/UIHrPage";

export function useHrImplementationList() {
  const selectedCompany = useAtomValue(selectedCompanyState);

  const onlyActiveImplementations = useAtomValue(
    onlyActiveImplementationsState
  );

  const {
    data: implementedBenefits,
    isLoading: implementationLoading,
    isRefetching: implementationRefetching,
  } = useGetBenefitImplementations({
    countryCode: Number(selectedCompany?.countryCode),
    clientInternalNumberGOS: Number(selectedCompany?.clientInternalNumberGos),
    benefitCategoryTag: 0,
    onlyActive: onlyActiveImplementations,
  });

  return {
    implementedBenefits,
    implementationLoading,
    implementationRefetching,
  };
}
